import * as React from 'react'
import { Button, Dialog, DialogBody, DialogFooter, Intent } from '@blueprintjs/core'
import { useState } from 'react'

interface Props {
  title: string
  body: string | React.ReactElement
  submitButtonIntent?: Intent
  isOpen: boolean
  onClose: () => void
  onSubmit: () => void
}

export const UnlockForPickingConfirmation = ({
  title,
  body,
  submitButtonIntent = Intent.WARNING,
  onSubmit,
  isOpen,
  onClose
}: Props) => {
  const [loading, setLoading] = useState(false)

  const handleSubmit = async () => {
    setLoading(true)
    try {
      await onSubmit()
    } finally {
      setLoading(false)
      onClose()
    }
  }

  return (
    <>
      <Dialog title={title} isOpen={isOpen} onClose={onClose}>
        <DialogBody>
          <span>{body}</span>
        </DialogBody>
        <DialogFooter
          actions={
            <>
              <Button onClick={onClose} minimal>
                Cancel
              </Button>
              <Button
                onClick={() => {
                  handleSubmit()
                }}
                intent={submitButtonIntent}
                loading={loading}
              >
                Unlock
              </Button>
            </>
          }
        />
      </Dialog>
    </>
  )
}
